import 'date-fns';
import React, { Component, Fragment } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import SimpleReactValidator from 'simple-react-validator';
import { InputLabel, TextField, IconButton, Button, Select, MenuItem } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import PlusIcon from '@material-ui/icons/AddCircleOutline';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { itemService, globalService as gs } from '../../../../../common/services';
import { alertSelectors } from '../../../../../common/redux/selectors';
import { confirmAlert } from 'react-confirm-alert';
import { commonHelper } from '../../../../../helpers';

class AvailibilityForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DayList: props.Items,
            loading: false
        };
        
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'invalid-feedback d-block',
        });
    }

    handleChange = (e, index) => {
        const { name, value } = e.target;
        let DayList = [...this.state.DayList];
        DayList[index][name] = value;
        this.setState({ DayList });
    };

    // handle click event of the Remove button
    handleRemoveClick = (index, item) => {
        confirmAlert({
            //title: `Confirm Request`,
            message: 'Are you sure remove this avalability.',
            buttons: [
                {
                    label: 'No',
                    onClick: () => console.log('clear')
                },
                {
                    label: 'Yes',
                    onClick: () => {
                        const { dispatch } = this.props; 
                        if(item.id) {
                            itemService.availability("DELETE", null, {item_id: item.id}).then(data => {
                                if(data.success) {
                                    dispatch(alertSelectors.success('You have successfully delete the avalability'));
                                    const list = [...this.state.DayList];
                                    list.splice(index, 1);
                                    this.setState({DayList: list});
                                    this.props.Remove(item, true);
                                }
                            })
                            .catch(exception => {
                                gs.showErrors(dispatch, exception, alertSelectors);
                                this.setState({loading: false});
                            });
                        } else {
                            const list = [...this.state.DayList];
                            list.splice(index, 1);
                            this.setState({DayList: list});
                            this.props.Remove(item, false);
                        }
                    }
                }
            ]
        });
    };

    // handle click event of the Add button
    handleAddClick = (day) => {
        this.setState({
            ...this.state,
            DayList: [...this.state.DayList, { week_day: this.props.day, start_time: '', end_time: '', status: 1, blank_id: Math.floor((Math.random() * 10000) + 1) }],
        });
        this.props.Add(this.props.day, 'create');
    };

    handleSubmit = (item, day, index) => {
        if( this.validator.allValid() ) {
            const { dispatch } = this.props; 
            const { DayList } = this.state;
            this.setState({loading: true});
            let params = item.id ? {item_id: item.id} : null;
            let UserAvailability = {
                week_day: day,
                start_time: item.id ? item.start_time : DayList[index].start_time,
                end_time: item.id ? item.end_time : DayList[index].end_time,
                status: 1
            }
            //console.log('Update', UserAvailability);
            itemService.availability("POST", {UserAvailability}, params).then(data => {
                if(data.success) {
                    dispatch(alertSelectors.success('You have successfully update the avalability'));
                    this.props.Update();
                    this.setState({loading: false});
                } else {
                    dispatch(alertSelectors.error('The availability is overlapped.'));
                }
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                this.setState({loading: false});
            });
            
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        this.validator.purgeFields();
        const { DayList, loading } = this.state;
        const { day, Items } = this.props;

        return (<div className="list w-100">
            <h3 className="d-flex">
                <span className="day col pl-0">{day}</span> 
                <IconButton color="primary" variant="contained" onClick={() => this.handleAddClick()}><PlusIcon /></IconButton></h3>
            <div className="d-flex flex-wrap mb-3 availability ">
                {Items && Items.map((x, i) => {
                    return (
                      
                        <section className="login-page pb-2 col-xl-6" key={`avail-${i}`}>
                            <div className="box d-flex flex-wrap login-box" key={Math.floor((Math.random() * 10000) + 1)}>
                                <div className="form">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <InputLabel>Start Time</InputLabel>
                                                <Select name="start_time" value={DayList && DayList[i] && DayList[i].start_time} onChange={(e) => this.handleChange(e, i)}>
                                                    <MenuItem value=""><em>-Select Time-</em></MenuItem>
                                                    {Object.entries(commonHelper.customTimes()).map(([key, value]) =>
                                                        <MenuItem key={`start-${key}`} value={key}>{value}</MenuItem>
                                                    )}
                                                </Select>
                                                {/* <TextField 
                                                size="medium" 
                                                value={DayList && DayList[i] && DayList[i].start_time} 
                                                type="time"
                                                name="start_time"
                                                className={'input-box w-100'}
                                                onChange={(e) => this.handleChange(e, i)} /> */}
                                                {this.validator.message('start_time', DayList && DayList[i] && DayList[i].start_time, 'required')}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <InputLabel>End Time</InputLabel>
                                                <Select name="end_time" value={DayList && DayList[i] && DayList[i].end_time} onChange={(e) => this.handleChange(e, i)}>
                                                    <MenuItem value=""><em>-Select Time-</em></MenuItem>
                                                    {Object.entries(commonHelper.customTimes()).map(([key, value]) =>
                                                        <MenuItem key={`end-${key}`} value={key}>{value}</MenuItem>
                                                    )}
                                                </Select>
                                                {/* <TextField 
                                                className={'input-box w-100'}
                                                size="medium" 
                                                value={DayList && DayList[i] && DayList[i].end_time} 
                                                type="time"
                                                name="end_time"
                                                onChange={(e) => this.handleChange(e, i)} /> */}
                                                {this.validator.message('end_time', DayList && DayList[i] && DayList[i].end_time, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="action">
                                    {/* <IconButton color="primary" variant="contained" onClick={() => this.handleRemoveClick(i, x)}><DeleteIcon /></IconButton>
                                    <LaddaButton className="btn btn-submit btn-primary" loading={loading} data-style={EXPAND_RIGHT} onClick={() => this.handleSubmit(x, day, i)}>Submit</LaddaButton> */}
                                    <IconButton color="primary" variant="contained" onClick={() => this.handleRemoveClick(i, x)}><DeleteIcon /></IconButton>
                                    {(x && x.id === undefined) ? 
                                    <Button color="primary" variant="contained" className="submit" onClick={() => this.handleSubmit(x, day, i)}>
                                        Submit {DayList && DayList[i] && DayList[i].id}
                                    </Button> : 
                                    <Button color="secondary" variant="contained" className="update" onClick={() => this.handleSubmit(x, day, i)}>
                                        Update
                                    </Button>}
                                </div>
                            </div>
                        </section>
                      
                    );
                })}
                {Items && Items.length === 0 && <div style={{marginTop: '-10px', color:'#2B388F'}}>{day} availability not found</div>}
            </div>
                
        </div>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(AvailibilityForm);
